__turbopack_context__.v({
  "root": "RingSizeGuideModal-module__0yg9gG__root",
});
